import { render } from "./FullScreenSmoothSliderComp.vue?vue&type=template&id=267e9460&scoped=true"
import script from "./FullScreenSmoothSliderComp.vue?vue&type=script&lang=js"
export * from "./FullScreenSmoothSliderComp.vue?vue&type=script&lang=js"

import "./FullScreenSmoothSliderComp.vue?vue&type=style&index=0&id=267e9460&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-267e9460"]])

export default __exports__